import { Label, UIText1, Avatar, Link } from '@cian/ui-kit';
import { IconActionArrowRight16, IconToggleStarOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';
import { IDeveloperInfo } from '../../../../../types/developerInfo';
import { getRoomLinks } from '../../helpers/developerInfoHelpers';
interface IDeveloperInfoProps {
  developerInfo: IDeveloperInfo;
}

export const DeveloperInfo: React.FC<IDeveloperInfoProps> = ({ developerInfo }) => {
  const roomLinks = React.useMemo(() => {
    return getRoomLinks(developerInfo.flatsStat);
  }, [developerInfo.flatsStat]);

  return (
    <div className={style['container']} data-testid="DeveloperInfo">
      <div className={style['avatar']}>
        <Avatar src={developerInfo.logoUrl} size={80} type="builder" hideBorder />
      </div>

      <div className={style['text-block']}>
        <div className={style['title-row']}>
          <a className={style['title']} href={developerInfo.url as string} target="_blank" rel="noreferrer">
            {developerInfo.name}
          </a>
          <div className={style['labels']}>
            {developerInfo.rate && (
              <Label
                background="surface-inverted-default"
                color="decorative-orange"
                borderColor="accent-main-secondary"
                borderStyle="solid"
                borderWidth={1}
                icon={<IconToggleStarOn16 color="decorative-orange" />}
              >
                {developerInfo.rate}
              </Label>
            )}
            {developerInfo.isReliable && (
              <Label
                background="surface-inverted-default"
                color="text-main-default"
                borderColor="accent-main-secondary"
                borderStyle="solid"
                borderWidth={1}
              >
                Надёжный
              </Label>
            )}
          </div>
        </div>

        <div className={style['info-row']}>
          {developerInfo.since && <UIText1 color="text-primary-default">Работает с {developerInfo.since} года</UIText1>}

          {developerInfo.url && (
            <Link
              href={developerInfo.url}
              target="_blank"
              rel="noreferrer"
              fontSize="M"
              color="current_color"
              afterIcon={<IconActionArrowRight16 color="current_color" />}
            >
              Подробнее о застройщике
            </Link>
          )}

          {developerInfo.newobjectsStats &&
            developerInfo.newobjectsStats?.map((stat, index) => (
              <Link
                key={index}
                href={stat.url as string}
                target="_blank"
                rel="noreferrer"
                fontSize="M"
                color="current_color"
                afterIcon={<IconActionArrowRight16 color="current_color" />}
              >
                {stat.name as string}
              </Link>
            ))}
        </div>

        {roomLinks.length > 0 && (
          <div className={style['room-links']}>
            {roomLinks.map(link => (
              <a key={link.label} href={link.url} className={style['room-link']}>
                <UIText1 color="current_color">{link.label}</UIText1>
                <UIText1 color="text-secondary-default">{link.count}</UIText1>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
